import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import filterList from '../../../data/mou_category.json';
import Banner from '../../atoms/Banner/Banner';
import MouCardMolecules from '../../molecules/MouCardMolecules/MouCardMolecules';
import MouFilter from '../../molecules/MouFilter';
import contentsList from '../../../data/mou.json';

const bannerData = {
  imgSrc: '/images/image/footprint@2x.png',
  imgSrcM: '/images/image/foot print m@2x.png',
  title: 'MOU',
  text1: 'Best of the Best is establishing cooperative relationships with various major institutions to nurture top talent.',
};

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '1000px',
  },
  contents: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContentL: 'center',
  },

  contentsList: {
    display: 'flex',
    justifyContent: 'center',
  },
});
export default function MouPage() {
  const classes = useStyles();
  const [list, setList] = useState(contentsList);
  const [filterName, setFilterName] = useState('all');
  const buttonClick = (e) => {
    setFilterName(e.id);
    let array = [];
    for (let i = 0; i < contentsList.length; i++) {
      if (e.id === contentsList[i].categoryId) {
        array.push(contentsList[i]);
      }
    }
    setList(array);

    // 필터링 해주는 역할
  };

  const handleAllClick = (e) => {
    setFilterName('all');
    setList(contentsList);
  };
  return (
    <Box className={classes.root}>
      <Box className={classes.contents}>
        <Banner bannerData={bannerData}></Banner>

        <MouFilter filterList={filterList} handleAllClick={handleAllClick} filterName={filterName} buttonClick={buttonClick}></MouFilter>
        <Box className={classes.contentsList}>
          <MouCardMolecules contentsList={list}></MouCardMolecules>
        </Box>
      </Box>
    </Box>
  );
}
